type Snapshot = {
  success: boolean;
  metric_version?: number;
  scope: 'team' | 'me';
  generated_at: string;
  expires_at?: string;
  whatsapp_text: string;
};

export function canCopyMorningSummary(summary: Snapshot | null, scope: 'team' | 'me', now = Date.now()) {
  return !!summary?.success && summary.metric_version === 2 && summary.scope === scope
    && !!summary.whatsapp_text && Date.parse(summary.generated_at) <= now
    && Date.parse(summary.expires_at ?? '') > now;
}
